<div class="vault-container">
  <app-layout></app-layout>

  <div class="vault-section">
    <!-- Overlay for mobile sidebar -->
    <div class="album-overlay" [class.active]="isAlbumMenuOpen" (click)="closeAlbumMenu()"></div>

    <!-- LEFT SIDEBAR -->
    <div class="vault-left-content" [class.active]="isAlbumMenuOpen">
      <div class="vault-header d-flex justify-content-between align-items-center px-4">
        <div class="vault-brand">
          <!-- Replaces the old left icon rail's Home link. Two marks, swapped
               by breakpoint in CSS: the 345px sidebar has no room for the
               wordmark, so desktop gets the "L" icon alone and mobile the
               full "LINK". -->
          <img src="assets/login/header-logo.png" alt="Home" class="vault-brand-logo vault-brand-logo--icon"
            (click)="goHome()" title="Back to home" />
          <img src="assets/login/link-logo.png" alt="Home" class="vault-brand-logo vault-brand-logo--full"
            (click)="goHome()" title="Back to home" />
          <h3>Vault <span class="count-meta">{{ this.totalFolder }}</span></h3>
        </div>
        <div class="nav-right">
          <div class="creat-album">
            <button class="create-btn" (click)="handleCreateButtonClick()">
              + Create
            </button>
          </div>
        </div>
      </div>


      <!-- Vault has two sections since 23 Oct 2026: Media (this screen) and the Knowledge base.
           Its own row: the 345px header has no room beside "+ Create". -->
      <nav class="vault-sections" aria-label="Vault sections">
        <span class="vault-section-tab active"><i class="fas fa-photo-video"></i> Media</span>
        <a class="vault-section-tab" routerLink="/vault/knowledge" title="Open the knowledge base">
          <i class="fas fa-book"></i> Knowledge base
        </a>
      </nav>

      <div class="fx-album-search-container">
        <i class="fas fa-search search-icon" (click)="applyAlbumSearch()"></i>

        <input type="text" class="form-control search-input" placeholder="Search Folders..."
          [ngModel]="albumSearchQuery" (ngModelChange)="onAlbumSearchChange($event)"
          (keyup.enter)="applyAlbumSearch()" />

        @if (albumSearchQuery) {
        <i class="fas fa-times clear-icon" (click)="clearAlbumSearch()" title="Clear search"></i>
        }

        <div class="tooltip-wrapper">
          <button class="btn-advanced-search" [class.active]="showAdvancedSearch" (click)="toggleAdvancedSearch()"
            type="button" aria-label="Advanced Search">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"
              stroke-linecap="round" stroke-linejoin="round">
              <!-- Main Search Circle -->
              <circle cx="11" cy="11" r="8"></circle>
              <!-- Search Handle -->
              <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
              <!-- Advanced Filter Indicators -->
              <line x1="8" y1="9" x2="14" y2="9"></line>
              <line x1="8" y1="13" x2="12" y2="13"></line>
            </svg>
          </button>
          <span class="custom-tooltip">Advanced Search</span>
        </div>
      </div>

      @if (showAdvancedSearch) {
      <div class="vault-advanced-search-container">
        <div class="advanced-search-header">
          <h2 class="header-title">Advanced search</h2>
          <button class="close-btn" (click)="closeAdvancedSearch()" type="button" aria-label="Close">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
        </div>

        <div class="advanced-search-content">
          <!-- Type Selection -->
          <div class="filter-section">
            <p class="section-label">SEARCH TYPE</p>
            <div class="search-type-grid">
              <button type="button" [class.active]="advSearchType === 'text'" (click)="setAdvSearchType('text')">
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M4 7V4h16v3M9 20h6M12 4v16" />
                </svg>
                <span>Text to Image</span>
              </button>
              <button type="button" [class.active]="advSearchType === 'image'" (click)="setAdvSearchType('image')">
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
                  <circle cx="8.5" cy="8.5" r="1.5"></circle>
                  <polyline points="21 15 16 10 5 21"></polyline>
                </svg>
                <span>Image to Image</span>
              </button>
            </div>
          </div>

          <!-- Text Input for Text to Image -->
          @if (advSearchType === 'text') {
          <div class="search-input-field">
            <p class="section-label">SEARCH TEXT</p>
            <div class="input-container">
              <svg class="search-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                stroke-width="2">
                <circle cx="11" cy="11" r="8"></circle>
                <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
              </svg>
              <input type="text" placeholder="Try: dog sitting on a beach..." [(ngModel)]="advTextQuery"
                (keyup.enter)="performAdvancedSearch()" />
              @if (advTextQuery) {
              <button type="button" class="clear-search-btn" (click)="advTextQuery = ''">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <line x1="18" y1="6" x2="6" y2="18"></line>
                  <line x1="6" y1="6" x2="18" y2="18"></line>
                </svg>
              </button>
              }
            </div>
          </div>
          }

          <!-- Image File Input for Image to Image -->
          @if (advSearchType === 'image') {
          <div class="filter-section">
            <p class="section-label">SEARCH IMAGE</p>
            <div class="image-dropzone" (click)="onDropzoneClick(advFileInput)" (dragover)="onImageDragOver($event)"
              (drop)="onImageDrop($event)">
              <input #advFileInput type="file" accept="image/*" style="display:none;"
                (change)="onAdvImageSelected($event)" />
              @if (advSelectedImagePreview) {
              <div class="adv-image-preview-wrap" (click)="$event.stopPropagation()">
                <img [src]="advSelectedImagePreview" alt="Search image" class="adv-image-preview" />
                <button type="button" class="remove-adv-image" (click)="clearAdvImage($event, advFileInput)"
                  title="Remove image">×</button>
                <span class="adv-image-name text-truncate">{{ advSelectedImageFile?.name }}</span>
              </div>
              } @else {
              <div class="dropzone-prompt">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8">
                  <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
                  <circle cx="8.5" cy="8.5" r="1.5"></circle>
                  <polyline points="21 15 16 10 5 21"></polyline>
                </svg>
                <span>Select an image to search</span>
                <button type="button" class="btn-choose-file"
                  (click)="advFileInput.click(); $event.stopPropagation()">Choose file</button>
              </div>
              }
            </div>
          </div>
          }

          <!-- Date Range -->
          <div class="filter-section">
            <p class="section-label">DATE RANGE</p>
            <div class="date-flex">
              <input type="date" [(ngModel)]="advStartDate" #startInput (click)="startInput.showPicker?.()"
                class="date-input" />
              <span class="date-arrow">→</span>
              <input type="date" [(ngModel)]="advEndDate" #endInput (click)="endInput.showPicker?.()"
                class="date-input" />
            </div>
          </div>

          <!-- Action Footer -->
          <div class="action-footer">
            <button type="button" class="search-btn" (click)="performAdvancedSearch()" [disabled]="isAdvSearching">
              @if (isAdvSearching) {
              <span class="spinner-border spinner-border-sm" role="status"></span>
              <span>Searching...</span>
              } @else {
              <span>Search</span>
              }
            </button>
            <button type="button" class="reset-btn" (click)="resetAdvancedSearch()">
              <span>Reset</span>
            </button>
          </div>
        </div>
      </div>
      } @else {
      <ul class="album-list mt-1">
        @for (album of allAlbums; track album._id) {
        <li class="album-item d-flex justify-content-between align-items-center"
          [class.active]="selectedAlbum?._id === album._id || folderTrail[0]?._id === album._id"
          [class.disabled]="(isUploading || isProcessingMedia) && album._id !== folderId"
          (click)="(!(isUploading || isProcessingMedia) || album._id === folderId) && selectAlbum(album); (!(isUploading || isProcessingMedia) || album._id === folderId) && closeAlbumMenu()"
          [style.pointerEvents]="(isUploading || isProcessingMedia) && album._id !== folderId ? 'none' : 'auto'"
          [style.opacity]="(isUploading || isProcessingMedia) && album._id !== folderId ? 0.5 : 1">
          <div class="folder-logo flex-shrink-0 mr-2">
            @if (album.folderLogo) {
            <img [src]="album.folderLogo" [alt]="album.folderName" />
            } @else {
            <i class="fas fa-folder"></i>
            }
          </div>

          <div class="album-info">
            <div class="album-row-top">
              <p class="folder-name mb-0 text-truncate">{{ album.folderName }}</p>
              <span class="album-date">{{ album.createdAt | date : "mediumDate" }}</span>
            </div>

            <div class="album-row-bottom">
              <small class="album-sub text-truncate">
                {{ album.creatorName }} · {{ folderCountLabel(album) }}
              </small>

              @if (isFolderOwner(album)) {
              <button class="folder-rename-btn" (click)="openRenameFolderModal(album, $event)" title="Rename folder">
                <i class="fas fa-pen"></i>
              </button>
              }
            </div>
          </div>
        </li>
        }

        @if (!isAlbumsLoading && allAlbums.length === 0) {
        <li class="text-center text-muted py-4 px-3" style="font-size: 13px">
          @if (albumSearchQuery) { No folders match “{{ albumSearchQuery }}”. } @else {
          No folders yet. }
        </li>
        }
      </ul>
      }


    </div>

    <!-- RIGHT CONTENT -->
    <div class="vault-right-content" [class.mobile-full]="isMobileView">
      <!-- MOBILE TOGGLE BUTTON (Hidden if we use the grid) -->
      <!-- <div class="mobile-album-toggle" (click)="toggleAlbumMenu()">Albums</div> -->

      @if (hasPerformedAdvSearch || isAdvSearching) {
      <div class="adv-search-right-view">
        <!-- Header -->
        <div class="adv-search-header-bar d-flex justify-content-between align-items-center">
          <div class="d-flex min-w-0 flex-grow-1 mr-2">
            <div class="adv-header-icon-box mr-3">
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"
                stroke-linecap="round" stroke-linejoin="round">
                <circle cx="11" cy="11" r="8"></circle>
                <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                <line x1="8" y1="9" x2="14" y2="9"></line>
                <line x1="8" y1="13" x2="12" y2="13"></line>
              </svg>
            </div>
            <div class="min-w-0 flex-grow-1">
              <div class="d-flex align-items-center flex-wrap adv-title-row" style="gap: 8px;">
                <h4 class="mb-0 fw-bold adv-title">Advanced Search Results</h4>
                <span class="badge adv-count-badge">{{ advTotalCount || advSearchResults.length }} found</span>
              </div>
              <div class="adv-query-meta mt-1 d-flex align-items-center flex-wrap" style="gap: 8px;">
                <span class="adv-type-pill">
                  {{ advSearchType === 'text' ? 'Text to Image' : 'Image to Image' }}
                </span>
                @if (advSearchType === 'text' && advTextQuery) {
                <span class="adv-query-text text-truncate">Query: “{{ advTextQuery }}”</span>
                }
                @if (advSearchType === 'image' && advSelectedImageFile) {
                <span class="adv-query-text text-truncate">Image: {{ advSelectedImageFile.name }}</span>
                }
                @if (advStartDate || advEndDate) {
                <span class="adv-date-pill">
                  <i class="fas fa-calendar-alt mr-1"></i>
                  {{ advStartDate || 'Start' }} → {{ advEndDate || 'End' }}
                </span>
                }
              </div>
            </div>
          </div>

          <div class="d-flex align-items-center flex-shrink-0">
            <button class="btn btn-outline-secondary btn-sm close-adv-results-btn" (click)="clearAdvSearchResults()"
              title="Clear Results">
              <i class="fas fa-times mr-1"></i>
              <span class="adv-btn-text">Clear Results</span>
            </button>
          </div>
        </div>

        <!-- Body / Results Grid -->
        <div class="adv-results-container p-4">
          @if (isAdvSearching) {
          <div class="adv-search-loading-state text-center py-5">
            <div class="spinner-border text-primary mb-3" style="width: 3.5rem; height: 3.5rem;" role="status"></div>
            <h5 class="fw-semibold text-dark">Searching media...</h5>
            <p class="text-muted small mb-0">Finding closest semantic visual matches from your data vault</p>
          </div>
          } @else if (advSearchResults.length === 0) {
          <div class="adv-search-empty-state text-center py-5">
            <div class="adv-empty-icon mb-3">
              <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="#94a3b8" stroke-width="1.5"
                stroke-linecap="round" stroke-linejoin="round">
                <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
                <circle cx="8.5" cy="8.5" r="1.5"></circle>
                <polyline points="21 15 16 10 5 21"></polyline>
              </svg>
            </div>
            <h5 class="fw-semibold text-dark">No matching media found</h5>
            <p class="text-muted small">Try searching with different keywords, another reference image, or an expanded
              date range.</p>
          </div>
          } @else {
          <div class="adv-gallery-grid">
            @for (item of advSearchResults; track item.mediaId || item._id || $index) {
            <div class="adv-media-card" (click)="previewAdvMedia(item)">
              <div class="adv-card-media-wrap">
                <img [src]="item.compressedImgUrl || item.fileUrl" [alt]="item.fileName" loading="lazy"
                  class="adv-card-img" />
                @if (item.score !== undefined && item.score !== null) {
                <div class="adv-score-tag">
                  <i class="fas fa-bolt mr-1"></i> {{ formatMatchScore(item.score) }}
                </div>
                }
              </div>
              <div class="adv-card-info">
                <p class="adv-card-filename text-truncate mb-0" [title]="item.fileName">{{ item.fileName }}</p>
              </div>
            </div>
            }
          </div>

          @if (advNextCursor && advNextCursor !== 'null') {
          <div class="adv-load-more-wrap text-center mt-4 mb-4">
            <button type="button" class="btn adv-load-more-btn" [disabled]="isLoadingMoreAdv"
              (click)="loadMoreAdvSearch()">
              @if (isLoadingMoreAdv) {
              <span class="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
              <span>Loading more...</span>
              } @else {
              <i class="fas fa-arrow-down mr-2"></i>
              <span>Load more results</span>
              }
            </button>
          </div>
          }
          }
        </div>
      </div>
      } @else {

      <!-- Default Vault Placeholder (Desktop) -->
      @if (!selectedAlbum && !isMobileView) {
      <div class="vault-gallery text-center">
        <img src="../../../../assets/vault/default-img.png" alt="Vault Placeholder" />
      </div>
      }

      <!-- Mobile Folder Grid (First Screen) -->
      @if (!selectedAlbum && isMobileView) {
      <div class="mobile-vault-wrap">
        <div class="mobile-grid-header d-flex justify-content-between align-items-center">
          <h2 class="mb-0">Vault <span class="count-meta">{{ totalFolder }}</span></h2>
          <button class="btn-create-custom" (click)="handleCreateButtonClick()">
            <span class="material-symbols-outlined" style="font-size: 20px;">add</span>
            Create
          </button>
        </div>

        <div class="mobile-vault-grid">
          <div class="row g-2">
            @for (album of allAlbums; track album._id) {
            <div class="col-6">
              <div class="folder-card gallery-style" (click)="selectAlbum(album)">
                <div class="folder-preview-grid">
                  @if (album.folderLogo) {
                  <div class="folder-logo-cover">
                    <img [src]="album.folderLogo" [alt]="album.folderName">
                  </div>
                  } @else if (album.previews && album.previews.length > 0) {
                  @for (preview of album.previews.slice(0, 4); track preview) {
                  <div class="preview-tile">
                    <img [src]="preview.url || preview.ogFileUrl" alt="preview">
                  </div>
                  }
                  <!-- Fill remaining slots if fewer than 4 previews -->
                  @if (album.previews.length < 4) { @for (empty of [].constructor(4 - album.previews.length); track
                    $index) { <div class="preview-tile empty">
                </div>
                }
                }
                } @else {
                <div class="preview-placeholder">
                  <i class="fas fa-folder-open"></i>
                </div>
                }
                <span class="item-count-badge">
                  {{ folderCountLabel(album) }}
                </span>
              </div>
              <div class="folder-info mt-1 d-flex justify-content-between align-items-start">
                <div class="min-w-0">
                  <p class="folder-grid-name mb-0 text-truncate">{{ album.folderName }}</p>
                  <small class="text-muted">{{ album.createdAt | date : "mediumDate" }}</small>
                </div>
                @if (isFolderOwner(album)) {
                <div class="folder-card-actions flex-shrink-0">
                  <button class="btn btn-sm btn-link text-muted p-0" (click)="openRenameFolderModal(album, $event)"
                    title="Rename folder">
                    <i class="fas fa-pen"></i>
                  </button>
                  <button class="btn btn-sm btn-link text-danger p-0" (click)="deleteAlbum(album, $event)"
                    title="Delete folder">
                    <i class="fas fa-trash"></i>
                  </button>
                </div>
                }
              </div>
            </div>
          </div>
          }
        </div>

        @if (allAlbums.length === 0) {
        <div class="text-center mt-5">
          <img src="../../../../assets/vault/default-img.png" alt="Empty" style="width: 150px; opacity: 0.5;">
          <p class="text-muted mt-3">No folders found</p>
        </div>
        }
      </div>
    </div>
    }

    <!-- Album Content -->
    @if (selectedAlbum) {
    <div class="vault-gallery-content">
      <!-- Gallery Header -->
      <div class="gallery-header d-flex justify-content-between align-items-center px-4 py-3">
        <div class="d-flex align-items-center min-w-0">
          @if (isMobileView || canGoUpFolder) {
          <button class="btn btn-link text-dark p-0 mr-3"
            (click)="parentFolderInTrail ? selectAlbum(parentFolderInTrail) : goBackToFolders()" title="Back">
            <i class="fas fa-arrow-left fa-lg"></i>
          </button>
          }

          <div class="folder-logo folder-logo-lg flex-shrink-0 mr-2">
            @if (selectedAlbum.folderLogo) {
            <img [src]="selectedAlbum.folderLogo" [alt]="selectedAlbum.folderName" />
            } @else {
            <i class="fas fa-folder"></i>
            }
          </div>

          <div class="min-w-0">
            @if (folderTrail.length > 1) {
            <nav class="vault-breadcrumb d-flex align-items-center">
              @for (crumb of folderTrail; track crumb._id; let last = $last;
              let first = $first) {
              <!-- Separator only between crumbs, so the trail no longer
                     opens with a stray "/" now the root link is gone. -->
              @if (!first) {
              <span class="crumb-sep">/</span>
              }
              @if (last) {
              <span class="crumb-current text-truncate">{{ crumb.folderName }}</span>
              } @else {
              <button class="crumb-link text-truncate" (click)="selectAlbum(crumb)">
                {{ crumb.folderName }}
              </button>
              }
              }
            </nav>
            }

            <div class="album-head d-flex align-content-center">
              <h4 class="album-head-name mb-1 mr-1 text-truncate">
                {{ selectedAlbum.folderName }}
              </h4>
              <span class="count-meta">{{ this.totalMedia }}</span>
            </div>
            <small class="text-muted d-block">
              {{ selectedAlbum.createdAt | date : "mediumDate" }}
            </small>
          </div>
        </div>

        <div class="view-options d-flex align-items-center">
          <button class="btn action-btn mr-2" (click)="openUploadModal(selectedAlbum)" title="Upload files">
            <i class="fas fa-plus"></i>
          </button>

          <!-- Nesting goes three levels, so this is hidden only at the
                 deepest one. -->
          @if (canHaveSubFolders(selectedAlbum)) {
          <button class="btn action-btn mr-2" (click)="openCreateFolderModal(selectedAlbum, $event)"
            [disabled]="!canAddSubFolder(selectedAlbum)" [title]="
                canAddSubFolder(selectedAlbum)
                  ? 'New subfolder'
                  : 'This folder already has the maximum of 20 subfolders'
              ">
            <i class="fas fa-folder-plus"></i>
          </button>
          }

          @if (isFolderOwner(selectedAlbum)) {
          <button class="btn action-btn mr-2" (click)="openRenameFolderModal(selectedAlbum, $event)"
            title="Rename folder">
            <i class="fas fa-pen"></i>
          </button>
          }

          <!-- Share Tooltip -->
          <div class="share-wrapper position-relative">
            <button class="btn action-btn mr-2" (click)="toggleAlbumShareTooltip()" title="Share Album"
              [class.action-button]="showAlbumShareTooltip">
              <i class="fas fa-share"></i>
            </button>

            @if (showAlbumShareTooltip) {
            <div class="share-tooltip card shadow position-absolute p-3">
              <!-- Close Icon -->
              <button class="btn-close btn-close-sm position-absolute" style="
                    top: 8px;
                    right: 8px;
                    font-size: 0.8rem;
                    border: none;
                    background: transparent;
                  " (click)="closeAlbumShareTooltip()" aria-label="Close share tooltip">
                <i class="fas fa-times"></i>
              </button>

              <p class="mb-2 fw-bold small font-16">Share Album Link</p>
              <div class="input-group input-group-sm">
                <input type="text" class="form-control form-control-sm" [value]="albumShareableLink" #albumShareInput
                  readonly placeholder="Generating link..." />
                <button class="btn btn-outline-primary mx-2" type="button" (click)="copyAlbumLink(albumShareInput)">
                  <i class="fas fa-copy"></i>
                </button>
              </div>
              @if (albumCopied) {
              <div class="text-success small mt-2">
                <i class="fas fa-check me-1"></i> Link copied!
              </div>
              }
            </div>
            }
          </div>
          @if (isFolderOwner(selectedAlbum)) {
          <button class="btn action-btn" (click)="deleteAlbum(selectedAlbum, $event)" title="Delete folder">
            <i class="fas fa-trash-alt"></i>
          </button>
          }
        </div>
      </div>

      <!-- gallery collection -->
      <div class="gallery-collection position-relative">
        <!-- TOOLBAR — view filter on the left, media filters on the right -->
        <div class="vault-toolbar">
          <div class="vault-view-tabs">
            <button class="vault-tab" [class.active]="vaultViewFilter === 'all'" (click)="setVaultViewFilter('all')">
              All
            </button>

            <!-- At the deepest level there are no folders to filter between. -->
            @if (showFolderTabs) {
            <button class="vault-tab" [class.active]="vaultViewFilter === 'folders'"
              (click)="setVaultViewFilter('folders')">
              Folders <span class="count-meta">{{ subFolders.length }}</span>
            </button>
            <button class="vault-tab" [class.active]="vaultViewFilter === 'media'"
              (click)="setVaultViewFilter('media')">
              Media <span class="count-meta">{{ totalMedia }}</span>
            </button>
            }

            <!-- Starred is an admin-curated view, but readable by everyone -->
            <button class="vault-tab" [class.active]="vaultViewFilter === 'featured'"
              (click)="setVaultViewFilter('featured')">
              <i class="fas fa-star mr-1"></i> Starred
            </button>
          </div>

          <!-- Kept mounted for the whole folder view. Gating this on the
                 loading flag or on groupedMedia destroyed the search input on
                 every keystroke's request and threw away its focus. -->
          @if (showMediaSection) {
          <div class="vault-toolbar-filters">
            <!-- Date Range Picker -->
            <div class="fx-date-range-container position-relative">
              <input #dateRangeInput class="fx-date-range tag" type="text" matInput ngxDaterangepickerMd
                [locale]="locale" [maxDate]="maxDate" [drops]="'down'" [opens]="'right'" [ranges]="ranges"
                [showCustomRangeLabel]="false" [alwaysShowCalendars]="true" [keepCalendarOpeningWithRange]="true"
                [showCancel]="true" [startKey]="'startDate'" [endKey]="'endDate'" [autoApply]="true" autocomplete="off"
                name="daterange" [(ngModel)]="selectedDateRange" (change)="onDateSelected($event)"
                (hide)="onDatepickerHide()" [placeholder]="isMobileView ? 'Date range' : 'Search by date range'"
                readonly />
              <!-- The calendar turns into a clear button once a range is
                     set, matching how the search field behaves. -->
              @if (selectedDateRange?.startDate || selectedDateRange?.endDate) {
              <i class="fas fa-times calendar-icon clear-date-icon"
                (click)="$event.stopPropagation(); clearDateFilter()" title="Clear date filter"></i>
              } @else {
              <i class="fas fa-calendar-alt calendar-icon"></i>
              }
            </div>

            <!-- SEARCH INPUT -->
            <div class="fx-search-container position-relative">
              <i class="fas fa-search" (click)="applyMediaSearch()"></i>
              <input type="text" class="form-control search-input tag"
                [placeholder]="isMobileView ? 'Search...' : 'Search media...'" [ngModel]="searchQuery"
                (ngModelChange)="onSearchMedia($event)" (keyup.enter)="applyMediaSearch()" />

              @if(searchQuery){
              <i class="fas fa-times" (click)="clearSearch()"></i>
              }
            </div>
          </div>
          }
        </div>

        <!-- Loader — covers both the folder and media requests -->
        @if (isVaultContentLoading) {
        <div class="media-loader-container">
          <div class="spinner-border text-primary" role="status"></div>
          <p class="mt-3 text-muted">Loading...</p>
        </div>
        }

        <!-- MULTI-SELECT BAR — floats over the grid rather than sitting in
               the flow, which pushed every card down on the first click. -->
        @if (showMediaSection && selectedMediaCount > 0) {
        <div class="selection-bar" title="Shift-click to select a range. Files you didn't upload are skipped.">
          <span class="selection-count">{{ selectedMediaCount }} selected</span>

          <button class="sel-link" (click)="selectAllLoadedMedia()">
            Select all
          </button>
          <button class="sel-link" (click)="clearMediaSelection()">
            Clear
          </button>

          <!-- Curation is admin-only, and the check covers the whole
                 request, so these stay hidden rather than erroring. -->
          @if (isVaultAdmin) {
          <span class="sel-divider"></span>

          <button class="sel-action" [disabled]="
                isBulkFeaturing || isBulkDeleting || selectedUnfeaturedCount === 0
              " (click)="bulkSetFeatured(true)" [title]="
                selectedUnfeaturedCount === 0
                  ? 'Everything selected is already starred'
                  : 'Star the selected files for everyone'
              ">
            <i class="fas fa-star"></i>
            {{ isBulkFeaturing ? "Working..." : "Star" }}
            @if (selectedUnfeaturedCount > 0) {
            <span class="count-meta">{{ selectedUnfeaturedCount }}</span>
            }
          </button>

          <button class="sel-action" [disabled]="
                isBulkFeaturing || isBulkDeleting || selectedFeaturedCount === 0
              " (click)="bulkSetFeatured(false)" [title]="
                selectedFeaturedCount === 0
                  ? 'Nothing selected is starred'
                  : 'Remove the star from the selected files'
              ">
            <i class="far fa-star"></i>
            Unstar
            @if (selectedFeaturedCount > 0) {
            <span class="count-meta">{{ selectedFeaturedCount }}</span>
            }
          </button>
          }

          <span class="sel-divider"></span>

          <button class="sel-action danger" [disabled]="isBulkDeleting || isBulkFeaturing"
            (click)="bulkDeleteSelected()">
            <i class="fas fa-trash"></i>
            {{ isBulkDeleting ? "Deleting..." : "Delete" }}
          </button>
        </div>
        }

        <!-- SCROLL REGION — the folders and the virtualised media grid share
               one scroller, so the folders scroll away with the media. -->
        <div id="scrollElement" #scrollElement class="virtual-container" [class.has-selection]="selectedMediaCount > 0"
          (scroll)="onVirtualScroll($event)">
          <!-- FOLDERS -->
          @if (showFoldersSection && !isVaultContentLoading) {
          <div class="subfolder-section" #foldersSection>
            <!-- Same heading treatment as a month group, so folders read as
                   the first section of one list rather than a separate pane. -->
            <h5 class="fw-bold mb-3">Folders</h5>

            @if (subFolders.length === 0) {
            <p class="text-muted small mb-2">No subfolders yet.</p>
            } @else {
            <div class="subfolder-grid">
              @for (sub of subFolders; track sub._id) {
              <div class="vault-folder-card" (click)="selectAlbum(sub)">
                <div class="vault-folder-thumb">
                  @if (sub.folderLogo) {
                  <img [src]="sub.folderLogo" [alt]="sub.folderName" />
                  } @else {
                  <i class="fas fa-folder"></i>
                  }
                </div>

                <div class="vault-folder-meta min-w-0">
                  <p class="mb-0 text-truncate">{{ sub.folderName }}</p>
                  <small class="text-muted">{{ folderCountLabel(sub) }}</small>
                </div>

                @if (isFolderOwner(sub)) {
                <div class="vault-folder-actions flex-shrink-0">
                  <button class="btn btn-sm btn-link text-muted p-0" (click)="openRenameFolderModal(sub, $event)"
                    title="Rename subfolder">
                    <i class="fas fa-pen" style="font-size: 12px"></i>
                  </button>
                  <button class="btn btn-sm btn-link text-danger p-0 ml-2" (click)="deleteAlbum(sub, $event)"
                    title="Delete subfolder">
                    <i class="fas fa-trash" style="font-size: 12px"></i>
                  </button>
                </div>
                }
              </div>
              }
            </div>
            }
          </div>
          }

          <!-- TanStack Virtual list -->
          @if (showMediaSection && !isVaultContentLoading && virtualGridData() && virtualGridData().length > 0) {
          <div [style.height.px]="virtualizer?.getTotalSize() || 0" style="position: relative; width: 100%">
            @for (virtualItem of virtualizer?.getVirtualItems() || []; track virtualItem.index) {
            @if (virtualGridData()[virtualItem.index]; as row) {
            <div [style.position]="'absolute'" [style.top.px]="virtualItem.start - foldersOffset()" [style.left]="0"
              [style.width]="'100%'" [style.height.px]="virtualItem.size" class="vertical-item">
              @if (row.type === 'header') {
              <h5 class="fw-bold mb-3 mt-2">{{ row.month }}</h5>
              } @else if (row.type === 'media-row') {
              <!-- Columns come from the same itemsPerRow the virtualiser
                         packed the row with; letting CSS auto-fill decide let
                         them disagree, which overflowed the row's fixed
                         height on narrow screens. -->
              <div class="gallery-items" [style.grid-template-columns]="
                        'repeat(' + (row.itemsPerRow || 1) + ', minmax(0, 1fr))'
                      ">
                @for (file of row.items; track trackByMediaId($index, file)) {
                <!-- Clicking the card selects it; clicking the thumbnail
                           opens the file full screen. -->
                <div class="gallery-item" [class.selected]="isMediaSelected(file)"
                  (click)="toggleMediaSelection(file, $event)">
                  <!-- Star toggles the featured flag. It is one shared
                             mark, not a personal favourite, so the wording
                             says so and only admins get the control. -->
                  @if (isVaultAdmin && !file.isProcessing) {
                  <button class="star-btn" [class.is-starred]="file.isFeatured" [disabled]="isFeaturePending(file)"
                    (click)="toggleFeatured(file, $event)" [title]="
                            file.isFeatured
                              ? 'Starred for everyone — click to remove'
                              : 'Star this for everyone'
                          ">
                    <i [class]="file.isFeatured ? 'fas fa-star' : 'far fa-star'"></i>
                  </button>
                  } @else if (file.isFeatured) {
                  <span class="star-btn is-starred static" title="Starred by an admin">
                    <i class="fas fa-star"></i>
                  </span>
                  }

                  <div class="media-content position-relative" style="cursor: pointer"
                    (click)="openMediaFromCard(file, $event)">
                    @if (file.isProcessing) {
                    <div class="d-flex justify-content-center align-items-center bg-light rounded shadow-sm"
                      style="width: 182px; height: 120px">
                      <div class="spinner-border text-primary" role="status" style="
                                width: 3rem;
                                height: 3rem;
                                color: var(--border-light) !important;
                                margin-bottom: 13px;
                              "></div>
                      <div class="processing-label position-absolute" style="
                                bottom: 60px;
                                font-size: 14px;
                                color: #5b5b5b;
                              ">
                        Processing...
                      </div>
                    </div>
                    } @else { @if (isImage(file)) {
                    <img [src]="file.compressedImgUrl" [alt]="file.fileName" class="img-overlay rounded shadow-sm"
                      style="width: 175px; height: 120px; object-fit: cover" loading="lazy" decoding="async" />
                    } @else if (isMediaVideo(file)) {
                    <div class="video-thumb-wrapper position-relative">
                      <img [src]="file.thumbnailUrl" [alt]="file.fileName" class="rounded shadow-sm" style="
                                width: 175px;
                                height: 120px;
                                object-fit: cover;
                              " loading="lazy" decoding="async" />
                      <div
                        class="video-overlay position-absolute start-0 w-100 h-100 d-flex flex-column justify-content-between align-items-stretch p-1"
                        style="
                                background: rgba(0, 0, 0, 0.25);
                                top: 0;
                                border-radius: 4px;
                              ">
                        <!-- Play Button -->
                        <div class="d-flex justify-content-start">
                          <button class="btn btn-sm play-btn" style="
                                    width: 28px;
                                    height: 28px;
                                    display: flex;
                                    justify-content: center;
                                    align-items: center;
                                    padding: 0;
                                    opacity: 0.9;
                                  " title="Play video">
                            <i class="fas fa-play" style="font-size: 12px; color: #fff"></i>
                          </button>
                        </div>

                        <!-- Duration -->
                        <div class="d-flex justify-content-end align-items-end">
                          <div class="video-meta d-flex align-items-center gap-1 text-white px-1 py-0 rounded" style="
                                    background: rgba(0, 0, 0, 0.5);
                                    font-size: 12px;
                                  ">
                            <i class="fas fa-video"></i>
                            <span class="ml-1">{{
                              getVideoDuration(file)
                              }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    } @else {
                    <img [src]="file.compressedImgUrl" [alt]="file.fileName" class="rounded shadow-sm"
                      style="width: 175px; height: 120px; object-fit: cover" loading="lazy" decoding="async" />
                    } }

                    <p class="mt-2 mb-0 text-truncate" style="max-width: 175px">
                      {{ file.fileName }}
                    </p>
                    <small class="text-muted d-block">{{
                      file.uploadedByName
                      }}</small>
                  </div>

                  <div class="d-flex justify-content-between align-items-center mt-1">
                    <small class="text-muted">{{
                      file.updatedAt | date : "mediumDate"
                      }}</small>
                    <div class="d-flex align-items-center">
                      @if (isMediaOwner(file)) {
                      <button class="btn btn-sm btn-link text-muted p-0 mr-2"
                        (click)="openRenameMediaModal(file, $event)" title="Rename this file" style="line-height: 1">
                        <i class="fas fa-pen" style="font-size: 13px"></i>
                      </button>
                      <button class="btn btn-sm btn-link text-danger p-0" (click)="
                                deleteMediaFile($event, file._id, file.fileName)
                              " title="Delete this file" style="line-height: 1">
                        <i class="fas fa-trash" style="font-size: 14px"></i>
                      </button>
                      }
                    </div>
                  </div>
                </div>
                }
              </div>
              }
            </div>
            }
            }
          </div>
          }

          @if (isScrollLoading) {
          <div class="text-center py-3 position-relative z-index-1">
            <div class="spinner-border spinner-border-sm text-primary" role="status"></div>
            <p class="mt-3 text-muted" style="color: #7b94d5">
              Loading more...
            </p>
          </div>
          }

          <!-- Empty Filter State -->
          @if (showMediaSection && !isVaultContentLoading && isFilteredView && groupedMedia.length === 0) {
          <div class="no-data-found text-center py-5">
            <img src="../../../../assets/vault/file.png" alt="Empty Album" class="mb-3"
              style="width: 160px; opacity: 0.7" />
            <h5 class="text-muted">No data found</h5>
            <p class="text-secondary">
              Try adjusting your filters to see more results.
            </p>
          </div>
          }

          <!-- EMPTY ALBUM STATE -->
          @if (showMediaSection && !isVaultContentLoading && !isFilteredView && groupedMedia.length === 0)
          {
          <div class="empty-album text-center mt-5">
            <img src="../../../../assets/vault/file.png" alt="Empty Album" class="mb-3"
              style="width: 160px; opacity: 0.7" />
            @if (vaultViewFilter === 'featured') {
            <h5 class="text-muted">Nothing starred yet</h5>
            <p class="text-secondary mb-3">
              An admin can star files to show them here.
            </p>
            } @else {
            <h5 class="text-muted">This album is empty</h5>
            <p class="text-secondary mb-3">Add some media to get started.</p>
            <button class="btn" (click)="openUploadModal(selectedAlbum)">
              <i class="fas fa-plus me-1"></i>
            </button>
            }
          </div>
          }
        </div>
      </div>
    </div>
    }
    }
  </div>
</div>

<!-- Create / Rename Folder Modal -->
<!-- Angular-controlled, not a Bootstrap modal: showing through the plugin
       and closing by hand left its internal state stuck open, so the modal
       only ever opened once and its backdrop stayed on the page. -->
@if (isFolderModalOpen) {
<!-- No backdrop-click close: it discarded a half-typed name too easily.
       Use Cancel or the × instead. -->
<div class="vault-modal-overlay">
  <div class="vault-modal-card" (click)="$event.stopPropagation()">
    <div class="d-flex justify-content-end align-items-center">
      <button type="button" class="close" (click)="closeCreateModal()" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

    <!-- Cropping takes over the whole dialog, so Save cannot be pressed
           while a crop is still pending. -->
    @if (showLogoCropper) {
    <div class="logo-cropper">
      <p class="logo-cropper-title">Crop logo</p>

      <image-cropper [imageChangedEvent]="logoCropEvent" [maintainAspectRatio]="true" [aspectRatio]="1"
        [resizeToWidth]="512" [onlyScaleDown]="true" format="png" (imageCropped)="onLogoCropped($event)"
        (loadImageFailed)="onLogoCropFailed()"></image-cropper>

      @if (folderLogoError) {
      <p class="text-danger small mb-0 mt-2">{{ folderLogoError }}</p>
      }

      <div class="d-flex justify-content-end mt-3">
        <button type="button" class="cancel-btn mr-2" (click)="cancelLogoCrop()">
          Cancel
        </button>
        <button type="button" class="create-btn" [disabled]="!logoCropReady" (click)="applyLogoCrop()">
          Apply
        </button>
      </div>
    </div>
    } @else {

    @if (folderModalParent) {
    <p class="text-muted small mb-0">
      Inside <strong>{{ folderModalParent.folderName }}</strong>
    </p>
    }

    <!-- FOLDER LOGO (optional) — sits above the name, with icon actions
           overlaid on the preview instead of text buttons beside it. -->
    <div class="folder-logo-picker">
      <div class="folder-logo-row">
        <div class="folder-logo-preview">
          @if (folderLogoPreview) {
          <img [src]="folderLogoPreview" alt="Folder logo preview" />
          } @else {
          <div class="folder-logo-empty"><i class="fas fa-folder"></i></div>
          }
        </div>

        <div class="folder-logo-actions">
          <button type="button" class="logo-action change" (click)="logoInput.click()"
            [title]="folderLogoPreview ? 'Change logo' : 'Add logo'">
            <i class="fas fa-camera"></i>
          </button>

          <!-- Only offered when there is a stored logo to clear, so the
                 "Folder does not have a logo!" error stays unreachable. -->
          @if (folderModalMode === 'edit' && folderModalTarget?.folderLogo) {
          <button type="button" class="logo-action remove" [disabled]="isRemovingLogo" (click)="removeFolderLogo()"
            title="Remove logo">
            <i class="fas" [class.fa-trash]="!isRemovingLogo" [class.fa-spinner]="isRemovingLogo"></i>
          </button>
          }
        </div>
      </div>

      <input id="folderLogoInput" type="file" #logoInput class="d-none" [accept]="folderLogoAccept"
        (change)="onFolderLogoSelected($event)" />

      <small class="text-muted">
        Optional. JPG, PNG, GIF or WEBP, up to 5 MB.
      </small>
      @if (folderLogoError) {
      <p class="text-danger small mb-0">{{ folderLogoError }}</p>
      }
    </div>

    <div class="album-content">
      <!-- Carries what the modal header used to say. -->
      <label class="folder-field-label" for="folderNameInput">
        {{ folderModalTitle }}
      </label>
      <input id="folderNameInput" type="text" class="form-control album-name-input"
        [placeholder]="folderNamePlaceholder" maxlength="100"
        [class.is-invalid]="maxLengthExceeded || duplicateAlbumError" [ngModel]="folderNameValue"
        (ngModelChange)="onAlbumNameInput($event)" (keyup.enter)="saveFolder()" />
      @if (maxLengthExceeded) {
      <p class="text-danger small mb-2 mt-2">
        Folder name cannot be more than 100 characters.
      </p>
      } @if (duplicateAlbumError) {
      <p class="text-danger small mb-2 mt-2">
        Folder name already exists. Please choose another name.
      </p>
      }
    </div>

    <div class="d-flex justify-content-end mt-4">
      <button type="button" class="cancel-btn mr-2" (click)="closeCreateModal()">
        Cancel
      </button>
      <button type="button" class="create-btn" [disabled]="isSavingFolder" (click)="saveFolder()">
        {{ isSavingFolder ? "Saving..." : "Save" }}
      </button>
    </div>

    }
  </div>
</div>
}

<!-- Upload Modal -->
<div id="uploadModal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="uploadModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg upload" role="document">
    <div class="modal-content upload-container">
      <div class="modal-header border-0">
        <h5 class="modal-title" id="uploadModalLabel">
          Upload to <span id="modalAlbumName"></span>
        </h5>
        <button type="button" class="close" (click)="hideUploadModal()" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <div class="modal-body pt-2 pb-2 px-4" (dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)"
        (drop)="onDrop($event)" [class.drag-over]="isDragOver">
        @if(!selectedFiles.length){
        <div class="upload-dropzone" (click)="fileInput.click()" (dragover)="onDragOver($event)"
          (dragleave)="onDragLeave($event)" (drop)="onDrop($event)" [class.drag-over]="isDragOver">
          <div class="upload-icon">
            <i class="fas fa-cloud-upload-alt fa-3x"></i>
          </div>
          <p>Drag & Drop files here or click to browse</p>
          <input type="file" multiple #fileInput class="d-none" [accept]="allowedMediaAccept"
            (change)="onFilesSelected($event)" />
        </div>

        }

        <!-- Selected Files Preview -->
        @if(selectedFiles.length > 0){
        <div class="selected-files mt-3">
          <h6 class="mb-2">Selected Files:</h6>
          <ul class="list-group">
            @for(preview of filePreviews; track preview.name){
            <li class="list-group-item d-flex justify-content-between align-items-center">
              <div class="d-flex align-items-center">
                @if(!preview.type.startsWith('image/')){
                <i class="fas fa-file-alt text-secondary me-2"></i>
                } @if(preview.type.startsWith('image/')){
                <img [src]="preview.preview" class="rounded me-2"
                  style="width: 30px; height: 30px; object-fit: cover" />
                }
                <span class="text-truncate" style="max-width: 200px">{{
                  preview.name
                  }}</span>
              </div>
              <small class="text-muted">{{ (preview.size / 1024 / 1024).toFixed(1) }} MB</small>
            </li>
            }
          </ul>
        </div>
        }
      </div>

      <div class="modal-footer border-0">
        <button type="button" class="cancel-btn" (click)="hideUploadModal()">
          Cancel
        </button>
        <button type="button" class="create-btn" [class.disabled]="selectedFiles.length === 0"
          [disabled]="selectedFiles.length === 0" (click)="uploadVaultFiles(); hideUploadModal()">
          Upload
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Upload Progress Floating Box -->
@if (showUploadBox) {
<div class="upload-progress-box shadow position-fixed bottom-0 end-0 m-3 p-3 rounded">
  <!-- Uploading Header -->
  @if (!uploadSuccess) {
  <div class="upload-header d-flex justify-content-between align-items-center">
    <div>
      <strong>Uploading Files...</strong>
      <span>{{ uploadedCount }}/{{ totalFiles }}</span>
    </div>
    <button type="button" class="btn btn-sm btn-link text-muted" (click)="closeUploadBox()">
      <i class="fas fa-times"></i>
    </button>
  </div>
  }

  <!-- Success Header -->
  @if (uploadSuccess) {
  <div class="upload-header d-flex justify-content-between align-items-center text-success">
    <div class="d-flex align-items-center gap-2">
      <i class="fas fa-check-circle mx-2"></i>
      <strong>Upload Complete!</strong>
    </div>
    <button type="button" class="btn btn-sm btn-link text-muted" (click)="closeUploadBox()">
      <i class="fas fa-times"></i>
    </button>
  </div>
  }

  <!-- Progress Section -->
  @if (!uploadSuccess) {
  <div class="overall-progress mt-2">
    <div class="progress">
      <div class="progress-bar bg-primary" role="progressbar" [style.width]="overallProgress + '%'"></div>
    </div>
    <small>{{ overallProgress }}%</small>
  </div>
  } @if (!uploadSuccess) {
  <div class="current-file mt-2">
    <strong class="text-truncate d-block">{{ currentFileName }}</strong>
    <small>{{ uploadProgress[currentFileName] || 0 }}% of current file</small>
  </div>
  }
</div>
}

<!-- Full screen Overlay -->
@if(selectedMedia){
<div class="fullscreen-overlay" (click)="closeFullScreen()">
  <div class="fullscreen-content" (click)="$event.stopPropagation()">
    <!-- Header -->
    <div class="fullscreen-header d-flex justify-content-between align-items-center">
      <div class="file-info d-flex align-items-center gap-3">
        <button class="btn back-btn" (click)="closeFullScreen()">
          <i class="fas fa-arrow-left"></i> <span>Back</span>
        </button>
        <div>
          <h5 class="mb-0 text-truncate" style="max-width: 200px">
            {{ selectedMedia.fileName }}
          </h5>
          <small class="text-muted">{{
            formatFileSize(selectedMedia.size)
            }}</small>
        </div>
      </div>

      <div class="fullscreen-controls d-flex align-items-center">
        @if (selectedMedia.isFeatured && !isVaultAdmin) {
        <span class="fullscreen-star mr-2" title="Starred by an admin">
          <i class="fas fa-star"></i>
        </span>
        }

        @if (isVaultAdmin) {
        <button class="btn btn-sm btn-light me-2 mr-2 feature-btn" [class.is-featured]="selectedMedia.isFeatured"
          [disabled]="isFeaturePending(selectedMedia)" (click)="toggleFeatured(selectedMedia, $event)" [title]="
              selectedMedia.isFeatured
                ? 'Starred for everyone — click to remove'
                : 'Star this for everyone'
            ">
          <i [class]="selectedMedia.isFeatured ? 'fas fa-star' : 'far fa-star'"></i>
        </button>
        }

        @if (isMediaOwner(selectedMedia)) {
        <button class="btn btn-sm btn-light me-2 mr-2" (click)="openRenameMediaModal(selectedMedia, $event)"
          title="Rename">
          <i class="fas fa-pen"></i>
        </button>
        }

        <!-- Download -->
        <button class="btn btn-sm btn-light me-2" (click)="downloadMedia()" title="Download">
          <i class="fas fa-download"></i>
        </button>
      </div>
    </div>

    <!-- Swiper Container -->
    <div class="swiper-container fullscreen-swiper" id="fullscreenSwiper">
      <div class="swiper-wrapper">
        @for (file of allMedia; track file._id || file.mediaId || file.fileUrl || $index; let i = $index) {
        <div class="swiper-slide d-flex flex-column align-items-center justify-content-center">
          <!-- IMAGE -->
          @if (isImage(file)) {
          <img [src]="file.compressedImgUrl || file.fileUrl || file.url || file.ogFileUrl" [alt]="file.fileName"
            class="fullscreen-image" />
          }

          <!-- VIDEO -->
          @if (isVideo(file) && file.isProcessing) {
          <img [src]="file.thumbnailUrl" [alt]="file.fileName" class="fullscreen-image" />
          } @else if (isVideo(file)) {
          <video [src]="file.fileUrl" controls class="fullscreen-video"></video>
          }

          <!-- OTHERS -->
          @if (!isImage(file) && !isVideo(file)) {
          <div class="fullscreen-document text-center">
            <i class="fas fa-file fa-6x text-secondary mb-3"></i>
            <h4>{{ file.fileName }}</h4>
            <p class="text-muted">{{ formatFileSize(file.size) }}</p>
            <button class="btn btn-primary btn-lg" (click)="downloadMedia(file)">
              <i class="fas fa-download me-2"></i> Download File
            </button>
          </div>
          }

          <!-- Caption -->
          <!-- <div class="file-caption text-center mt-3">
                <h5 class="mb-0 text-truncate">{{ file.fileName }}</h5>
                <small class="text-muted">{{ file.uploadedByName }}</small>
              </div> -->
        </div>
        }
      </div>

      <!-- Swiper Navigation -->
      <div class="swiper-button-next"></div>
      <div class="swiper-button-prev"></div>
      <div class="swiper-pagination"></div>
    </div>
  </div>
</div>
}

<!-- Rename Media -->
@if (renameMediaTarget) {
<!-- Same here: closing on a stray backdrop click lost the typed name. -->
<div class="rename-media-overlay">
  <div class="rename-media-card" (click)="$event.stopPropagation()">
    <div class="d-flex justify-content-between align-items-center mb-3">
      <h5 class="mb-0">Rename File</h5>
      <button type="button" class="close" (click)="closeRenameMediaModal()" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

    <div class="rename-input-group d-flex align-items-center">
      <input type="text" class="form-control" placeholder="File name" maxlength="255"
        [class.is-invalid]="!!renameMediaError" [(ngModel)]="renameMediaBaseName" (keyup.enter)="saveMediaRename()" />
      <!-- The extension is preserved server-side, so it is not editable. -->
      @if (renameMediaExtension) {
      <span class="rename-extension">{{ renameMediaExtension }}</span>
      }
    </div>

    @if (renameMediaError) {
    <p class="text-danger small mb-0 mt-2">{{ renameMediaError }}</p>
    }

    <div class="d-flex justify-content-end mt-4">
      <button type="button" class="cancel-btn mr-2" (click)="closeRenameMediaModal()">
        Cancel
      </button>
      <button type="button" class="create-btn" [disabled]="isRenamingMedia" (click)="saveMediaRename()">
        {{ isRenamingMedia ? "Saving..." : "Save" }}
      </button>
    </div>
  </div>
</div>
}
</div>